import { Component, OnInit } from '@angular/core';
import { AuthService } from './login.service';

import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/map';
import { ToasterService } from 'angular2-toaster';
import { ConfigService } from '../shared/config.service';

@Component({
    selector: 'login',
    providers: [AuthService],
    templateUrl: 'login.component.html'
})

export class LoginComponent implements OnInit{
    errorResponse: any;
    notificationTitle: any;
    notificationContent: any;
    notificationType: any;
    submitted = false;
    buildNumber;

    constructor(
        private toasterService: ToasterService,
        private configService: ConfigService,
        private auth: AuthService) { }

    ngOnInit() {
        this.buildNumber = this.configService.envVars.BUILD_NUMBER || 'Local';
    }

    userLogin(id: any, password: any) {
        this.submitted = true;
        if (id === '' || password === '') {
            this.notificationType = 'error';
            this.notificationTitle = 'Error';
            this.notificationContent = 'Required Username and Password!';
            this.createNotification();
            this.submitted = false;

        } else {
            this.auth.login(id, password)
                .then()
                .catch(error => {
                    this.submitted = false;
                    this.errorHandler(error);
                });
        }
    }



    createNotification() {
        switch (this.notificationType) {
            case 'success':
                // this._service.success(this.notificationTitle, this.notificationContent);
                this.toasterService.pop('success', this.notificationTitle, this.notificationContent);
                break;
            case 'error':
                this.toasterService.pop('error', this.notificationTitle, this.notificationContent);
                // this._service.error(this.notificationTitle, this.notificationContent);
                break;
            case 'info':
                this.toasterService.pop('info', this.notificationTitle, this.notificationContent);
                // this._service.info(this.notificationTitle, this.notificationContent);
                break;
        }
    }

    errorHandler(error: any) {
        this.notificationType = 'error';
        this.notificationTitle = 'Error';
        const jsonErrorBody = JSON.parse(error._body);
        this.notificationContent = jsonErrorBody.error.message;
        if (this.notificationContent === 'Invalid authentication credentials') {
            this.auth.logout();
        }
        this.createNotification();
    }
};



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts